import { Card } from 'react-bootstrap';
import { useAuth } from "./AuthContext";
import { useSearchParams, Link } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { user, loading } = useAuth();
  const [searchParams] = useSearchParams();
  const linkReason = searchParams.get('reason');

  const CF_BASE = "https://d2b3xd88n081z3.cloudfront.net";

  const linkMessages = {
    invalid: "link No Longer Valid",
    missing: "No Link Provided",
    error:   "Something went wrong. Please try again.",
  };

  if (loading) return null;

  if (!user) {
    return (
      <div

      >
        <video
          autoPlay
          loop
          muted
          playsInline
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            zIndex: -1,
          }}
        >
          <source src={`${CF_BASE}/public/backgroundgrey2.mp4`} />
          Your browser does not support the video tag.
        </video>

        <Card
          className='card-body container col-10 col-md-6 justify-content-center'
          style={{
            overflow: 'hidden',
            boxSizing: 'border-box',
            maxWidth: '700px',
            position: 'relative',
            color: 'silver',
            borderRadius: '10px'
          }}
        >
          <h1
            className="password-heading1"
            style={{ textAlign: 'center', justifyContent: 'center' }}
          >
            {linkReason && linkMessages[linkReason]
              ? linkMessages[linkReason]
              : "You must be logged in to access this page"
            }
          </h1>
                
                        <h2 className='container col-12 justify-content-center'
                        style={{ textAlign: 'center',}}
                        >
                          Go to&nbsp;
                           <Link to="/Login"
                           className='hover-brighten'
                           
                            
                            > Login</Link>
                          </h2>
        </Card>
      </div>
    );
  }

  return children;
};

export default PrivateRoute;